<template>
    <div v-if="!hash">
        <form-header title="Instrumenten-Strukturförderung" subtitle="" tag="">
        </form-header>
        <ValidationObserver ref="form">
            <div class="bg-primary">
                <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <transition name="fade">
                        <div
                            class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                            v-show="formbehaviour.alertrequired"
                        >
                            <div class="md:grid md:grid-cols-1 md:gap-3">
                                <div class="md:col-span-1">
                                    <h3 class="leading-3">
                                        Bitte überprüfen Sie Ihre Eingabe!
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div
                            class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                            v-show="formbehaviour.alertForDocumentsRequired"
                        >
                            <div class="md:grid md:grid-cols-1 md:gap-3">
                                <div class="md:col-span-1">
                                    <h3 class="leading-3">
                                        Der Upload des "Angebot" ist für jedes
                                        Instrument zwingend notwendig.
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <form-section title="Angaben zur Musikschule">
                        <drop-down
                            label="Musikschulerhalter"
                            v-model="ansuchen.musikschulerhalterId"
                            rules="required"
                            :values="musikschulerhalter"
                        >
                        </drop-down>
                        <file-upload
                            label="Aufstellung des vorhandenen Schulinstrumentariums"
                            :maxSize="5"
                            tooltip="Aufstellung des bereits vorhandenen Instrumentariums der Musikschule. Diese kann entfallen, wenn das Instrumentarium im Musikschulverwaltungsprogramm erfasst ist."
                            @size-exceeded="onSizeExceeded"
                            @metadata="onVorhandenesInstrumentarium"
                            @fileloaded="onVorhandenesInstrumentariumLoad"
                        ></file-upload>
                    </form-section>
                    <div
                        v-for="(instrument, index) in ansuchen.instrumente"
                        :key="index"
                    >
                        <form-section
                            :title="index + 1 + '. Instrument'"
                            subtitle="Hinweis: Das Angebot ist zwingend erforderlich."
                        >
                            <text-input
                                label="Anzukaufendes Instrument"
                                rules="required|max:150"
                                v-model="instrument.anzukaufendesInstrument"
                                columns="3"
                                tooltip="Genaue Beschreibung des Instruments lt. Angebot - wichtig für die Bestimmung der Qualität des Instruments."
                            ></text-input>
                            <drop-down
                                label="Fach"
                                rules="required"
                                v-model="instrument.fachId"
                                columns="3"
                                :values="faecher"
                                tooltip="Bitte wählen Sie die zugehörige Fachbezeichnung des Instruments laut MKM Gesamt-Fächerliste"
                            ></drop-down>
                            <text-input
                                label="Anzahl"
                                rules="required|numeric"
                                v-model="instrument.anzahl"
                                columns="3"
                                tooltip="Wenn um Förderung für mehrere gleiche Instrumente lt. Angebot angesucht werden soll"
                            ></text-input>
                            <text-input
                                label="Einzelpreis lt. Angebot (brutto)"
                                rules="required|decimal:2"
                                :value="instrument.formattedPreis"
                                @input="onPreisChanged($event, index)"
                                columns="3"
                                tooltip="Gefördert werden maximal 40% des veranschlagten Kaufpreises (brutto), sowie max. EUR 4.000.- Die finanzielle Unterstützung für den Ankauf von Mangelinstrumenten des ansuchenden Schulerhalters, darf in den letzten drei Förderjahren die Summe von EUR 10.000,- nicht überschritten haben. Das Instrument darf erst im geplanten Anschaffungsjahr, im Kalenderjahr nach dem Ansuchen, angekauft werden. Die Förderung kann nur von Musikschulen lt. Musikschulplan bzw. den jeweiligen Erhaltern beansprucht werden."
                            ></text-input>
                            <text-area-input
                                label="Begründung Instrumentenankauf"
                                rules="required|max:2000"
                                v-model="instrument.begruendung"
                                columns="6"
                                rows="5"
                                tooltip="Begründung für die Notwendigkeit des Instrumentenankaufs im Sinne der qualitativen Weiterentwicklung der betreffenden Musikschule und/oder der Musikschulregion."
                            ></text-area-input>
                            <text-area-input
                                label="Qualifikation Lehrkräfte"
                                rules="required|max:2000"
                                v-model="instrument.lehrkraefteQualifikation"
                                columns="6"
                                rows="2"
                                tooltip="Name der Lehrkräfte, sowie Angaben zur Einstufung, zur Studienrichtung und den Studienabschlüssen"
                            ></text-area-input>
                            <file-upload
                                label="Angebot"
                                :maxSize="5"
                                @size-exceeded="onSizeExceeded"
                                @metadata="onAngebot($event, index)"
                                @fileloaded="onAngebotLoad($event, index)"
                            >
                            </file-upload>

                            <button
                                v-show="index != 0"
                                @click="removeInstrument(index)"
                                type="button"
                                class="col-span-3 text-center sm:px-2 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-red active:bg-red-700 transition ease-in-out duration-150"
                            >
                                Instrument entfernen
                            </button>
                        </form-section>
                    </div>
                    <div
                        class="mt-6 mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
                    >
                        <div class="sm:grid sm:grid-cols-3 sm:gap-6">
                            <div class="sm:col-span-1">&nbsp;</div>
                            <span class="inline-flex rounded-md">
                                <button
                                    @click="addInstrument"
                                    type="button"
                                    class="inline-flex items-center px-48 sm:px-4 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                                >
                                    Weiteres Instrument hinzufügen
                                </button>
                            </span>
                        </div>
                    </div>
                    <form-section
                        title="Bestätigung"
                        subtitle="Bitte geben Sie die E-Mailadresse an, an welche eine Eingangsbestätigung gesendet werden soll."
                    >
                        <text-input
                            v-model="ansuchen.bestaetigungsemail"
                            label="E-Mail"
                            rules="required|email"
                            columns="4"
                        ></text-input>
                        <div class="col-span-6">
                            <fieldset>
                                <div class="mt-4">
                                    <check-box
                                        v-model="zustimmungen.hinweis"
                                        label="Hinweis"
                                        rules="required"
                                        :description="
                                            textbausteinfuer(
                                                'zustimmungen.hinweis'
                                            )
                                        "
                                    ></check-box>
                                </div>
                            </fieldset>
                        </div>
                    </form-section>
                    <div
                        class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
                    >
                        <div class="sm:grid sm:grid-cols-3 sm:gap-6">
                            <div class="sm:col-span-1">&nbsp;</div>
                            <span class="inline-flex rounded-md shadow-sm">
                                <button
                                    @click="openSubmitModal()"
                                    type="button"
                                    class="inline-flex items-center px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                                >
                                    Ansuchen absenden
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
            >
                <div
                    v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto"
                >
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg
                                        class="h-6 w-6 text-green-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p
                                        class="text-sm leading-5 font-medium text-gray-900"
                                    >
                                        Validierung erfolgreich.
                                    </p>
                                    <p
                                        class="mt-1 text-sm leading-5 text-gray-500"
                                    >
                                        Übermittle das Ansuchen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                v-show="formbehaviour.showSendModal"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.showSendModal"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.showSendModal"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
                >
                    <div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Ansuchen absenden
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Nach dem Absenden können Sie das Ansuchen als PDF herunterladen. Bitte lassen Sie das Ansuchen unterschreiben und übermitteln dieses an uns.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
                    >
                        <span
                            class="flex w-full rounded-md shadow-sm sm:col-start-2"
                        >
                            <button
                                @click="sendAnsuchen()"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Absenden
                            </button>
                        </span>
                        <span
                            class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1"
                        >
                            <button
                                @click="formbehaviour.showSendModal = false"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Zurück
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
            >
                <div
                    v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto"
                >
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg
                                        class="h-6 w-6 text-green-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p
                                        class="text-sm leading-5 font-medium text-gray-900"
                                    >
                                        Validierung erfolgreich.
                                    </p>
                                    <p
                                        class="mt-1 text-sm leading-5 text-gray-500"
                                    >
                                        Übermittle das Ansuchen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.successful"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6"
                >
                    <div>
                        <div
                            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
                        >
                            <svg
                                class="h-6 w-6 text-green-600"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Erfolgreich gesendet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Sie können das Fenster nun schließen.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.successful"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6"
                >
                    <div>
                        <div
                            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
                        >
                            <svg
                                class="h-6 w-6 text-green-600"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Erfolgreich gesendet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Bitte drucken Sie den Antrag aus und
                                    übermitteln ihn unterschrieben per E-Mail an
                                    das Musik &amp; Kunst Schulen Management
                                    Niederösterreich.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-6">
                        <span class="flex w-full rounded-md shadow-sm">
                            <button
                                @click="generatePdf()"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Dokument herunterladen
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </transition>
        <div id="pdf"></div>
    </div>
</template>

<script>
import FormHeader from '@/components/forms/FormHeader.vue'
import FormSection from '@/components/forms/FormSection.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import TextInput from '@/components/inputs/TextInput.vue'
import FileUpload from '@/components/inputs/FileUpload.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import TextAreaInput from '@/components/inputs/TextAreaInput.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'
import * as JsPDF from 'jspdf'

export default {
    name: 'Form',
    inject: ['service'],
    props: {
        hash: {
            type: String,
            required: false,
        },
    },
    data: function() {
        return {
            formbehaviour: {
                alertrequired: false,
                showSendModal: false,
                openSubmitModal: false,
                sending: false,
                successful: false,
                alertForDocumentsRequired: false,
            },
            formdata: {
                textbausteine: [],
            },
            zustimmungen: {
                hinweis: null,
            },
            ansuchen: {
                musikschulerhalterId: null,
                musikschulerhalterBezeichnung: null,
                instrumente: [],
                bestaetigungsemail: null,
                vorhandenesInstrumentarium: {
                    subject: 'Upload - Vorhandenes Instrumentarium',
                    filename: null,
                    mimeType: null,
                    body: null,
                },
            },
            musikschulerhalter: [],
            faecher: [],
        }
    },
    components: {
        FormHeader,
        FormSection,
        DropDown,
        TextInput,
        FileUpload,
        CheckBox,
        TextAreaInput,
        TextBlock,
    },
    computed: {},

    methods: {
        async fetchTextBausteine() {
            const { data } = await this.service.formular
                .get('mangelinstrument')
                .textbloeckePowerApps()
            this.formdata.textbausteine = data
        },
        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            )

            if (!found) return id

            return found.contentPlain
        },

        removeInstrument(index) {
            this.ansuchen.instrumente.splice(index, 1)
        },

        addInstrument() {
            this.ansuchen.instrumente.push({
                anzukaufendesInstrument: null,
                fachId: null,
                begruendung: null,
                lehrkraefteQualifikation: null,
                preis: null,
                anzahl: '1',
                formattedPreis: null,
                angebot: {
                    subject: 'Upload - Angebot',
                    filename: null,
                    mimeType: null,
                    body: null,
                },
            })
        },
        async fetchMusikschulerhalter() {
            const { data } = await this.service.musikschulerhalter.alle()

            this.musikschulerhalter = data
            this.musikschulerhalter.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            )
        },
        async fetchFaecher() {
            const { data } = await this.service.fach.pruefungsordnung()

            this.faecher = data
        },

        getAmountFromFormattedNumber(value) {
            var numAsString = value
                .split('.')
                .join('')
                .replace(',', '.')
            var number = parseFloat(numAsString)
            if (!number) return null

            return number
        },

        async openSubmitModal() {
            var validation = await this.$refs.form.validate()

            for (let instrument of this.ansuchen.instrumente) {
                if (!instrument.angebot.filename) {
                    this.formbehaviour.alertForDocumentsRequired = true
                    window.scrollTo(0, 0)
                    return
                }
            }

            if (!validation) {
                window.scrollTo(0, 0)
                this.formbehaviour.alertrequired = true
                return
            }

            this.formbehaviour.showSendModal = true
        },

        async sendAnsuchen() {
            try {
                this.ansuchen.musikschulerhalterBezeichnung = this.musikschulerhalter.find(
                    a => a.id == this.ansuchen.musikschulerhalterId
                ).bezeichnung

                this.formbehaviour.sending = true
                await this.service.mangelinstrumentfoerderung.senden(
                    this.ansuchen
                )
                this.formbehaviour.showSendModal = false
                this.formbehaviour.successful = true
            } catch (error) {
                console.log(Object.keys(error), error.message)
            } finally {
                this.formbehaviour.sending = false
            }
        },

        onPreisChanged(newValue, index) {
            var lastItemIsComma = newValue[newValue.length - 1] == ','

            var value = this.getAmountFromFormattedNumber(newValue)

            if (!value) {
                this.ansuchen.instrumente[index].formattedPreis = newValue
                return
            }

            this.ansuchen.instrumente[index].preis = value.toString()

            var parts = newValue.toString().split(',')
            var numbersBeforeDecimal = parts[0].split('.').join('')
            var numberOfDots = Math.trunc(numbersBeforeDecimal.length / 3) - 1

            if (numbersBeforeDecimal.length % 3 > 0) {
                numberOfDots += 1
            }

            for (var i = numberOfDots; i > 0; i--) {
                var indexForComma = numbersBeforeDecimal.length - i * 3
                numbersBeforeDecimal =
                    numbersBeforeDecimal.slice(0, indexForComma) +
                    '.' +
                    numbersBeforeDecimal.slice(indexForComma)
            }

            this.ansuchen.instrumente[
                index
            ].formattedPreis = numbersBeforeDecimal

            if (parts.length > 1) {
                this.ansuchen.instrumente[index].formattedPreis =
                    numbersBeforeDecimal + ',' + parts[1]
            }

            if (lastItemIsComma) {
                this.ansuchen.instrumente[index].formattedPreis =
                    numbersBeforeDecimal + ','
            }
        },

        onAngebot(file, index) {
            this.ansuchen.instrumente[index].angebot.mimeType = file.type
            this.ansuchen.instrumente[index].angebot.filename = file.name
        },

        onAngebotLoad(dataUri, index) {
            this.ansuchen.instrumente[index].angebot.body = dataUri
        },

        onVorhandenesInstrumentarium(file) {
            this.ansuchen.vorhandenesInstrumentarium.mimeType = file.type
            this.ansuchen.vorhandenesInstrumentarium.filename = file.name
        },

        onVorhandenesInstrumentariumLoad(dataUri) {
            this.ansuchen.vorhandenesInstrumentarium.body = dataUri
        },

        onSizeExceeded(size) {
            alert(`Datei mit ${size}MB zu groß. (Maximal ${size} MB)`)
        },

        generatePdf() {
            var doc = new JsPDF()

            let x = 20
            let y = 40

            var page = 1
            var pages = 1

            doc.setFontType('normal')
            doc.setFontSize(11)

            const logo = require('@/assets/img/logo.jpg')
            var imgLogo = new Image()
            imgLogo.src = logo
            const footerlogo = require('@/assets/img/footerlogo.png')
            var imgFooter = new Image()
            imgFooter.src = footerlogo
            doc.addImage(imgLogo, 'PNG', 140, 5, )
            doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)

            doc.text(x, y, 'An die')
            doc.text(
                x,
                y + 5,
                'MKM Musik & Kunst Schulen Management Niederösterreich GmbH'
            )
            doc.text(x, y + 10, 'Neue Herrengasse 10')
            doc.text(x, y + 15, '3100 St. Pölten')

            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y + 40, 'ANSUCHEN: Instrumenten-Strukturförderung')

            y = 90
            doc.setFontType('bold')
            doc.text(x, y, 'Musikschulerhalter:')
            doc.setFontSize(11)
            doc.setFontType('normal')
            doc.text(
                x,
                y + 6,
                this.musikschulerhalter.find(
                    a => a.id == this.ansuchen.musikschulerhalterId
                ).bezeichnung
            )
            y += 6
            var counter = 0
            this.ansuchen.instrumente.forEach(instrument => {
                if (
                    this.checkIfNewPageIsNeededAndSetDocument(
                        y + 18,
                        doc,
                        imgLogo,
                        imgFooter
                    )
                ) {
                    pages++
                    y = 45
                }
                y = y + 12
                counter++
                doc.setFontType('bold')
                doc.setFontSize(12)
                doc.text(x, y, counter + '. Instrument')
                doc.setFontType('normal')
                doc.setFontSize(11)

                doc.text(x, y + 6, 'Anzukaufendes Instrument:')
                doc.text(x, y + 12, 'Standardfach (MKM):')
                doc.text(x, y + 18, 'Anzahl:')
                doc.text(x, y + 24, 'Preis laut Angebot:')

                doc.text(
                    x + 60,
                    y + 6,
                    String(instrument.anzukaufendesInstrument)
                )
                doc.text(x + 60, y + 12, String(this.faecher.find(
                    a => a.id == instrument.fachId
                ).name))
                doc.text(x + 60, y + 18, String(instrument.anzahl))
                doc.text(
                    x + 60,
                    y + 24,
                    'EUR ' + String(instrument.formattedPreis)
                )

                y += 32
                var lines = doc.splitTextToSize(instrument.begruendung, 150)
                var begruendungLineCount = lines.length

                if (
                    this.checkIfNewPageIsNeededAndSetDocument(
                        y + 6 + 4.5 * begruendungLineCount,
                        doc,
                        imgLogo,
                        imgFooter
                    )
                ) {
                    pages++
                    y = 45
                }
                doc.text(x, y, 'Begründung Instrumentenkauf:')
                doc.text(x + 10, y + 6, lines)
                y += 12 + 4.5 * begruendungLineCount

                lines = doc.splitTextToSize(
                    instrument.lehrkraefteQualifikation,
                    150
                )
                var qualifikationLineCount = lines.length

                if (
                    this.checkIfNewPageIsNeededAndSetDocument(
                        y + 6 + 4.5 * qualifikationLineCount,
                        doc,
                        imgLogo,
                        imgFooter
                    )
                ) {
                    pages++
                    y = 45
                }
                doc.text(x, y, 'Qualifikation Lehrende:')
                doc.text(x + 10, y + 6, lines)
                y += 12 + 4 * qualifikationLineCount
            })

            if (
                this.checkIfNewPageIsNeededAndSetDocument(
                    y + 20,
                    doc,
                    imgLogo,
                    imgFooter
                )
            ) {
                pages++
            }
            y = 240

            doc.text(x, y + 20, '_________________________________')
            doc.text(x, y + 25, 'Datum, Unterschrift Musikschulleiter:in')

            doc.text(x + 95, y + 20, '_________________________________')
            doc.text(x + 95, y + 25, 'Datum Unterschrift Musikschulerhalter:in')

            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.4);
            doc.circle(x + 83, y, 15, 'S')
            doc.text(x + 76, y + 1.3, 'Stempel')

            for (let i = 1; i <= pages; i++) {
                doc.setPage(i)
                doc.text(`Seite ${i} von ${pages}`, 17, 285, 'left')
            }

            doc.save('Instrumenten-Strukturfoerderung.pdf')
        },

        checkIfNewPageIsNeededAndSetDocument(y, doc, imgLogo, imgFooter) {
            if (y > 260) {
                doc.addPage()
                doc.addImage(imgLogo, 'PNG', 140, 5)
                doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)
                return true
            }
            return false
        },

        async initData() {
            await this.addInstrument()
            await this.fetchMusikschulerhalter()
            await this.fetchTextBausteine()
            await this.fetchFaecher()
        },

        async fetchHashAndGeneratePdf(hash) {
            const {
                data,
            } = await this.service.mangelinstrumentfoerderung.byhash(hash)
            this.ansuchen = data

            for (let i = 0; i < this.ansuchen.instrumente.length; i++) {
                this.onPreisChanged(
                    String(this.ansuchen.instrumente[i].preis),
                    i
                ) //so formattedPreis is set for pdf
            }
            this.generatePdf()
        },
    },
    created() {
        this.initData().then(() => {
            if (this.hash) {
                this.fetchHashAndGeneratePdf(this.hash)
            }
        })
    },
}
</script>
